import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { theme } from 'antd';

import { ProactiveEngineStateEnum } from '@/constants/enums';

import { Date, dateFormat } from './MetricsTooltip';
import { TooltipContainer } from './styled';

const { useToken } = theme;

const PeriodInfo = ({ periodInfo, isSecondPeriod }: { periodInfo; isSecondPeriod? }) => {
  const { t } = useTranslation();
  const { token } = useToken();
  const { point, name, sameControllerStatusStartDate, sameControllerStatusEndDate } = periodInfo;
  const formattedSameControllerStatusStartDate = moment(+sameControllerStatusStartDate).format(dateFormat);
  const formattedSameControllerStatusEndDate = moment(+sameControllerStatusEndDate).format(dateFormat);

  return (
    <div>
      <Date date={point} className={!isSecondPeriod && 'dynamic-control-date'} />
      <div className="dynamic-control-container">
        {!isSecondPeriod && <span>{t('dynamicControl')}</span>}
        <div className="dynamic-control-legend-container">
          <div className="dynamic-control-legend">
            <div
              className="legend-square"
              style={{
                backgroundColor: name === ProactiveEngineStateEnum.Activated ? token.colorSuccess : token.colorError,
              }}
            />
            <span className="dynamic-control-label">
              {t(name === ProactiveEngineStateEnum.Activated ? 'on' : 'off')}
            </span>
          </div>
          <div className="dynamic-control-small-label">
            {formattedSameControllerStatusStartDate}&nbsp;-&nbsp;
            {sameControllerStatusEndDate ? formattedSameControllerStatusEndDate : t('now')}
          </div>
        </div>
      </div>
    </div>
  );
};

const DynamicControllerTooltip = observer(({ currentPeriodInfo, secondPeriodInfo, token }) => {
  return (
    <TooltipContainer className="dynamic-control-tooltip-container" theme={{ token }}>
      <PeriodInfo periodInfo={currentPeriodInfo} />
      {!!secondPeriodInfo?.point && <PeriodInfo periodInfo={secondPeriodInfo} isSecondPeriod />}
    </TooltipContainer>
  );
});

export default DynamicControllerTooltip;
